import actions from "./actions";
import dayjs from 'dayjs';

let instruction;

const initState = {
    instructionCreateState: false,
    instructionCreateResult: {},
    instructionInitState: false,
    instructionReadAllState: false,
    instructionReadState: false,
    instructionUpdateState: false,
    instructionUpdateResult: {},
    instructionDeleteState: false,
    instructions: [],
    pagination: {},
    instruction: {
    // panelRecurrence
        name: undefined,
        transaction_type: null,
        transaction_status: 'ready',
        frequency: 'month',
        every: 1,
        day: 1,
        month: undefined,
        date_from: undefined,
        date_to: undefined,
        send_email: true,
        post_dating: null,
        batch_processing: null,

        // panelEmail
        reply_to_email: undefined,
        subject: undefined,
        message: undefined,
        attach_pdf: false,

    },
    transactionType: null,
    transactionStatus: 'ready',
    frequency: 'month',
    sendEmailOn: true,
    postDating: null,
    batchProcessing: null,
    dateTo: null,
    functions: {},
    instructionReadNextTransactionDateState: false,
    nextTransactionDate: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.CREATE_INSTRUCTION_REQUEST:
            return {
                ...state,
                instructionCreateState: 'request',
            };
        case actions.CREATE_INSTRUCTION_SUCCESS:
            return {
                ...state,
                instructionCreateState: 'success',
                instructionCreateResult: action.instruction,
            };
        case actions.INIT_INSTRUCTION_REQUEST:
            return {
                ...state,
                instructionInitState: 'request',
            };
        case actions.INIT_INSTRUCTION_SUCCESS: {
            const { instruction } = action;
            return {
                ...state,
                instructionInitState: 'success',
                instructionReadState: 'success',
                instruction,
                transactionType: instruction.transaction_type,
                transactionStatus: instruction.transaction_status,
                frequency: instruction.frequency,
                sendEmailOn: instruction.send_email,
                nextTransactionDate: instruction.date_next,
            };
        }
        case actions.READ_INSTRUCTIONS_REQUEST:
            return {
                ...state,
                instructionReadAllState: 'request',
            };
        case actions.READ_INSTRUCTIONS_SUCCESS:
            return {
                ...state,
                instructionReadAllState: 'success',
                instructions: action.instructions,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.READ_INSTRUCTION_REQUEST:
            return {
                ...state,
                instructionReadState: 'request',
            };
        case actions.READ_INSTRUCTION_SUCCESS: {
            const instruction = {...action.instruction};
            instruction.date_from = dayjs(instruction.date_from);
            if (instruction.date_to)
                instruction.date_to = dayjs(instruction.date_to);

            return {
                ...state,
                instructionReadState: 'success',
                instruction,
                transactionType: instruction.transaction_type,
                transactionStatus: instruction.transaction_status,
                frequency: instruction.frequency,
                sendEmailOn: instruction.send_email,
            };
        }
        case actions.UPDATE_INSTRUCTION_REQUEST:
            return {
                ...state,
                instructionUpdateState: 'request',
            };
        case actions.UPDATE_INSTRUCTION_SUCCESS:
            return {
                ...state,
                instructionUpdateState: 'success',
                instructionUpdateResult: action.instruction,
            };
        case actions.DELETE_INSTRUCTION_REQUEST:
            return {
                ...state,
                instructionDeleteState: 'request',
            };
        case actions.DELETE_INSTRUCTION_SUCCESS:
            return {
                ...state,
                instructionDeleteState: 'success',
            };
        case actions.CHANGE_INSTRUCTION:
            instruction = {
                ...(action.reset ? initState.instruction : state.instruction),
                ...action.request,
            };

            return {
                ...state,
                instruction,
                transactionType: instruction.transaction_type,
                transactionStatus: instruction.transaction_status,
                frequency: instruction.frequency,
            };
        case actions.CHANGE_TRANSACTION_TYPE:
            return {
                ...state,
                transactionType: action.transactionType,
            };
        case actions.CHANGE_TRANSACTION_STATUS:
            return {
                ...state,
                transactionStatus: action.transactionStatus,
            };
        case actions.CHANGE_FREQUENCY:
            return {
                ...state,
                frequency: action.frequency,
            };
        case actions.CHANGE_SEND_EMAIL:
            return {
                ...state,
                sendEmailOn: action.isOn,
            };
        case actions.CHANGE_POSTING_DATE:
            return {
                ...state,
                postDating: action.postDating,
            };
        case actions.CHANGE_BATCH_PROCESSING:
            return {
                ...state,
                batchProcessing: action.batchProcessing,
            };
        case actions.SET_INSTRUCTION_DATE_TO:
            return {
                ...state,
                dateTo: action.date,
            };
        case actions.UPDATE_FUNCTIONS:
            return {
                ...state,
                functions: {
                    ...state.functions,
                    ...action.functions,
                },
            };

        case actions.READ_NEXT_TRANSACTION_DATE_REQUEST:
            return {
                ...state,
                instructionReadNextTransactionDateState: 'request',
            };
        case actions.READ_NEXT_TRANSACTION_DATE_SUCCESS:
            return {
                ...state,
                instructionReadNextTransactionDateState: 'success',
                nextTransactionDate: action.nextTransactionDate,
            };
        case actions.READ_NEXT_TRANSACTION_DATE_ERROR:
            return {
                ...state,
                instructionReadNextTransactionDateState: 'error',
            };

        case actions.RESET_INSTRUCTION:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
